<template>
  <section class="result-wrapper">
    <div class="banner insurance">
      <div class="container">
        <h1>{{ t('insurance.title') }}</h1>
        <h4 v-html="t('insurance.subtitle')" class="desktop-only"/>
      </div>
    </div>
    <div class="banner sections">
      <div class="container">
    <div class="blocks">
      <h3 v-html="t('insurance.subtitle2')" />
      <div class="row home-products items-4">
         <div class="d-flex">
          <nuxt-link v-for="item, index in types" :key="index" :to="item.path">
          <div class="card">
            <h2>{{ item.name }}</h2>
            <p v-html="item.desc" />
            <img :src="item.image">
          </div>
          </nuxt-link>
        </div>
      </div>
    </div>
    </div>
    </div>
</section>
</template>
<script>
import commonFunc from '~/assets/js/commonHelper.js'
export default {
  components: {
  },
  data: function () {
    return {
      types: [
        // { name: this.t('insurance.travel'), desc: this.t('insurance.travel_desc'), path: '/insurance/travel', image: '/img/icons/icon-travel.svg' },
        { name: this.t('insurance.decoration'), desc: this.t('insurance.decoration_desc'), path: '/insurance/decoration', image: '/img/icons/icon-decoration.svg' },
        // { name: this.t('insurance.helper'), desc: this.t('insurance.helper_desc'), path: '/insurance/helper', image: '/img/icons/icon-helper.svg' },
        { name: this.t('insurance.auto'), desc: this.t('insurance.auto_desc'), path: '/insurance/auto', image: '/img/icons/icon-auto.svg' },
        { name: this.t('insurance.store'), desc: this.t('insurance.store_subtitle'), path: '/insurance/store', image: '/img/icons/icon-store.svg' },
        { name: this.t('insurance.labor'), desc: this.t('insurance.labor_subtitle'), path: '/insurance/labor', image: '/img/icons/icon-labor.svg' },
        // { name: this.t('insurance.student'), desc: this.t('insurance.student_desc'), path: '/insurance/student', image: '/img/icons/icon-student.svg' }
      ]
    };
  },
  layout(context) {
    return "default";
  },
  head() {
    return {
      ...commonFunc.getSeoMeta(this.$store.state.layout.seo),
      bodyAttrs: {
        class: 'insurance-page'
      }
    }
  },
  async asyncData({ store, route }) {
    await store.dispatch("layout/fetchSeo", {
      path: route.path
    });
  },
  mounted() {
    const { calculateMethod, tenor, amount } = this.$route.query
    this.filtered = calculateMethod || tenor || amount
  },
  methods: {
    formatMoney: function(val) {
      return '$ ' + commonFunc.formatMoney(val);
    },
    getTypeUrl: function(type) {
      return '/p-loan/lead?type=' + type;
    },
    amountRangeChange: function (e) {
      this.$refs['amount-txt'].value = e.target.value
    },
    amountTxtChange: function (e) {
      this.$refs['amount-range'].value = e.target.value
    },
    amountChange: function (val) {
      this.amount = val;
      this.triggerFilter();
    },
    tenorChange: function (val) {
      this.tenor = val;
      this.triggerFilter();
    },
    rangeChange: function (e) {
      // this.amount = e.target.value;
      this.amount = 1000044
      e.preventDefault();
    },
    triggerFilter: function () {
      const params = { amount: this.amount };
      params.tenor = this.tenor
      if (this.calculateMethod !== "") {
        params.calculateMethod = this.calculateMethod;
      }
      if (this.selectedSort !== "") {
        const sortList = this.selectedSort.split("_")
        params.sort = sortList[0]
        params.order = sortList[1] === 'asc' ? 'ascending' : 'descending'
      }
      this.$router.push({
        query: params,
      });
    },
    resetFilter: function (e) {
      this.amount = 50000
      this.$refs['amount-range'].value = this.$refs['amount-txt'].value = this.amount
      $("input[name='filter-method']").prop('checked', false)
      $("input[name='filter-tenor']:eq(1)").prop('checked', true)
    },
    applyFilter: function (e) {
      $("#filter-modal").modal("hide")
      this.calculateMethod = $("input[name='filter-method']:checked").val()
      this.amount = this.$refs['amount-txt'].value
      this.tenor = $("input[name='filter-tenor']:checked").val()
      this.triggerFilter();
    },
    getSearchResult: async function () {
      this.loading = true
      const params = { type: 'loan' }
      const query = commonFunc.handleAlias(this.$route.path, this.$route.query)
      params.params = query
      this.filtered = query.calculateMethod || query.tenor || query.amount
      try {
        await this.$store.dispatch('search/fetchList', params)
        const list = JSON.parse(JSON.stringify(this.$store.state.search.list))
        list.forEach((item) => {
          item.params = params.params
          item.method = this.methodList[item.calculateMethod] || '-'
        })
        this.list = list
        this.loading = false
      } catch (error) {
        this.loading = false
      }
    }
  },
};
</script>